<template>
  <div>
    <div id="content" class="content animated slideInRight delay-1s">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{
                  room_details.id ? "Editar Adicional" : "Cadastrar Adicional"
                }}
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form id="form">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="description">
                            <span class="required">*</span> Título:
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            autocomplete="new-password"
                            v-model="room_details.title"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="description">
                            <span class="required">*</span> Pré selecionado?:
                          </label>
                          <div class="custom-control custom-switch">
                            <input
                              type="checkbox"
                              id="remember"
                              class="custom-control-input"
                              v-model="room_details.pre_selected"
                            />
                            <label
                              for="remember"
                              class="custom-control-label"
                            ></label>
                            <small id="emailHelp" class="form-text text-muted"
                              >Se esta opção estiver ativa, ela aparecerá como
                              selecionada nas buscas do aplicativo.</small
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="limit_reservation"
                            ><span class="required"></span> Empresa:
                          </label>
                          <v-select
                            :options="companies"
                            label="company_name"
                            :reduce="(companies) => companies.id"
                            class="style-chooser"
                            v-model="room_details.company_id"
                          >
                            <div slot="no-options">Carregando...</div>
                          </v-select>
                        </div>
                      </div>
                    </div>

                    <hr />
                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>
                    <div class="block text-right">
                      <a class="btn btn-add" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                      <router-link to="/room_details" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  data() {
    return {
      room_details: {
        title: "",
        pre_selected: "",
        company_id: "",
      },
      companies: [],
    };
  },
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      fd.append("title", self.room_details.title);
      fd.append("company_id", self.room_details.company_id);
      if (self.room_details.pre_selected) {
        fd.append("pre_selected", self.room_details.pre_selected);
      } else {
        fd.append("pre_selected", false);
      }

      if (self.room_details.id) {
        fd.append("id", self.room_details.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "room_details";

      let fd = self.makeFormData();

      if (self.room_details.id) {
        api += "/" + self.room_details.id;
      }

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/room_details");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCompanies: function (id) {
      const self = this;
      const api = self.$store.state.api + "companies?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.companies = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getRoomDetails: function (id) {
      const self = this;
      const api = self.$store.state.api + "room_details/" + id;

      self.$http
        .get(api)
        .then((response) => {
          self.room_details = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;
    self.getCompanies();
    if (id) {
      self.getRoomDetails(id);
    }
  },
  components: {
    vSelect,
  },
};
</script>
<style scoped>
.select {
  height: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/RoomsDetails/Add.vue